const aws_config_dev = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-2_Kp9DpRrdK',
      userPoolClientId: '5f93lfrqqh7nruhjiiin8qbeem',
      region: 'ap-southeast-2',
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: 'auth.app.w86dev.click',
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: ['https://form.w86dev.click'],
          redirectSignOut: ['https://form.w86dev.click'],
          responseType: 'token',
        },
        username: true,
        email: true,
        phone: true,
      },
    },
  },
  gg_client_id:
    '541992205730-ombu26ut0amuo794b59bku1kt08egofm.apps.googleusercontent.com',
};

const aws_config_prod = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-2_4pkuaVYZY',
      userPoolClientId: '7k5h7tnrnkdcg78d9ofpt1opij',
      region: 'ap-southeast-2',
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: 'authenticateme.app.workflow86.com',
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: ['https://form.workflow86.com'],
          redirectSignOut: ['https://form.workflow86.com'],
          responseType: 'token',
        },
        username: true,
        email: true,
        phone: true,
      },
    },
  },
  gg_client_id:
    '541992205730-eaa8et59jir07ttls4vqgci5hpe5hdr5.apps.googleusercontent.com',
};

// Use dev config only when explicitly set to dev, otherwise default to production
const aws_config =
  process.env.REACT_APP_STAGE === 'dev' ? aws_config_dev : aws_config_prod;

// Domain for cookie storage - same as parent to enable session sharing
export const currentDomain = window.location.host.includes('localhost')
  ? 'localhost'
  : process.env.REACT_APP_STAGE === 'dev'
    ? '.w86dev.click'
    : '.workflow86.com';

export default aws_config;
